module.exports = "<div class=\"text-center\" style=\"margin-top: 100px\">\r\n    <h3 class=\"color-maroon\">You are not authorized to perform this action.</h3>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./app/authentication/unauthorized.html
// module id = 320
// module chunks = 0